import { CellSelections } from '../../../../../common/table/TableTypes';
import { getFirstSelection } from './tableSelectionAccessors';
import { getEndCol, getEndRow, getStartCol, getStartRow } from './tableSelectionAccessors';
import { isSelectingRefColHeader, isSelectingRefRowHeader } from './tableSelectionPredicateUtils';

/**
 * Returns whether the first active selection starts from the column header reference row.
 */
export const isFirstSelectionRefColHeader = (cellSelections: CellSelections | undefined): boolean => {
    const firstSelection = getFirstSelection(cellSelections);
    return !!firstSelection && isSelectingRefColHeader(firstSelection);
};

/**
 * Returns whether the first active selection starts from the row header reference column.
 */
export const isFirstSelectionRefRowHeader = (cellSelections: CellSelections | undefined): boolean => {
    const firstSelection = getFirstSelection(cellSelections);
    return !!firstSelection && isSelectingRefRowHeader(firstSelection);
};

/**
 * Returns whether the current selection resolves to a single row.
 */
export const isSelectingSingleRow = (cellSelections: CellSelections | undefined): boolean => {
    const firstSelection = getFirstSelection(cellSelections);
    if (!firstSelection) return false;

    return getStartRow(firstSelection) === getEndRow(firstSelection) || isFirstSelectionRefColHeader(cellSelections);
};

/**
 * Returns whether the current selection resolves to a single column.
 */
export const isSelectingSingleColumn = (cellSelections: CellSelections | undefined): boolean => {
    const firstSelection = getFirstSelection(cellSelections);
    if (!firstSelection) return false;

    return getStartCol(firstSelection) === getEndCol(firstSelection) || isFirstSelectionRefRowHeader(cellSelections);
};
